export interface CustomViewFrame {
    viewId: string
    recordId?: string
}

export interface CustomViewFrameSource {
    viewId?: string
    record?: { id?: string }
    parentCustomView?: CustomViewFrameSource
}

export function readCustomViewStack(source?: CustomViewFrameSource): CustomViewFrame[] {
    const stack: CustomViewFrame[] = []
    const seen = new Set<CustomViewFrameSource>()
    let current = source
    while (current?.viewId && !seen.has(current)) {
        seen.add(current)
        stack.push({ viewId: current.viewId, recordId: current.record?.id })
        current = current.parentCustomView
    }
    return stack
}

/** 视图控制监听键。有外层记录时同时挂裸 id，页面上的按钮会打到全部实例。 */
export function getViewControlListenerIds(blockId: string, scope: string | undefined, frames: { recordId?: string }[]) {
    const bare = scope ? `${scope}@${blockId}` : blockId
    const seen = new Set<string>()
    const scoped: string[] = []
    for (const frame of frames) {
        if (!frame.recordId) {
            continue
        }
        const listenerId = `${bare}/${frame.recordId}`
        if (seen.has(listenerId)) {
            continue
        }
        seen.add(listenerId)
        scoped.push(listenerId)
    }
    return scoped.length > 0 ? [...scoped, bare] : [bare]
}

/** 不含裸 id。裸 id 留给「页面上的按钮，打到全部实例」。 */
export function getRecordScopedListenerIds(blockId: string, scope: string | undefined, frames: { recordId?: string }[]) {
    const bare = scope ? `${scope}@${blockId}` : blockId
    return getViewControlListenerIds(blockId, scope, frames).filter(listenerId => listenerId !== bare)
}

export function resolveControlRecordId(input: {
    controlElementId: string
    controlElementType?: string
    viewRecordId?: string
    customViewStack?: CustomViewFrame[]
    ancestorCustomViewIds?: string[]
    parentCustomViewIdOfControl?: string
    parentCustomViewIdOfTrigger?: string
}): string | undefined {
    const {
        controlElementId,
        controlElementType,
        viewRecordId,
        customViewStack,
        ancestorCustomViewIds,
        parentCustomViewIdOfControl,
        parentCustomViewIdOfTrigger
    } = input

    if (customViewStack?.length) {
        if (controlElementType === 'view') {
            const selfIndex = customViewStack.findIndex(frame => frame.viewId === controlElementId)
            if (selfIndex >= 0) {
                return customViewStack[selfIndex + 1]?.recordId
            }
        }
        if (ancestorCustomViewIds?.length) {
            const ancestorSet = new Set(ancestorCustomViewIds)
            const frame = customViewStack.find(item => ancestorSet.has(item.viewId) && item.recordId)
            if (frame?.recordId) {
                return frame.recordId
            }
        }
    }

    if (
        viewRecordId &&
        parentCustomViewIdOfControl &&
        parentCustomViewIdOfTrigger &&
        parentCustomViewIdOfControl === parentCustomViewIdOfTrigger
    ) {
        return viewRecordId
    }

    return undefined
}
